import BasicValidation from 'components/components/common/BasicValidation';
import isEmpty from 'lodash/isEmpty';
import mergeErrors from 'components/helpers/mergeErrors';
import TransHelper from 'components/common/translations/TransHelper';

export default class CustomerPhoneNumberValidation extends BasicValidation {
  constructor(countryCode, phoneNumber, locale) {
    super();
    this.countryCode = countryCode;
    this.phoneNumber = phoneNumber;
    this.locale = locale || "en";
    return this;
  }

  trans = (key, params = null) => {
    return TransHelper.translate(
      this.locale,
      'content.errors.auth.customerPhoneValidation.' + key,
      params
    );
  }

  validationPhone() {
    const { min, max } = this.phoneNumberLength();
    var phoneLength = this.phoneNumber.length;

    if (phoneLength < min || phoneLength > max) {
      var ret = 'Invalid phone number';
      if (min === max) {
        ret = this.trans('exactlyLength', { size: min });
      } else if (phoneLength < min) {
        ret = this.trans('minNumbersPre') + " " + min + " " + this.trans('minNumbersPost');
      } else if (phoneLength > max) {
        ret = this.trans('phoneToLong');
      }
      return ret;
    }

    return null;
  }

  phoneNumberLength() {
    var minLength = 8;
    var maxLenght = 11;
    if (this.countryCode === "+47") {
      minLength = 8;
      maxLenght = 8;
    }
    if (this.countryCode === "+48") {
      minLength = 9;
      maxLenght = 9;
    }
    return { min: minLength, max: maxLenght };
  }

  validationPhoneCountry() { //todo sprawdzic
    if (isEmpty(this.countryCode)) {
      return this.trans('countryCodeEmpty');
    }
    return null;
  }

  isValidPhone() { //todo sprawdzic
    return this.validationPhone() === null;
  }

  isValidPhoneCountry() { //todo sprawdzic
    return this.validationPhoneCountry() === null;
  }

  getError() {
    return mergeErrors(
      [this.validationPhone(), this.validationPhoneCountry()],
      true
    );
  }

  isValidForm() {
    return this.isValidPhone(data.phone)
  }
}